module.exports = __webpack_public_path__ + "img/AX.ed600a64.svg";